export default __webpack_public_path__ + "static/media/Gellix-RegularItalic.9f422106.woff";